import { ACTION_TYPE } from 'api/types';
import * as AddToJourneyNode from 'ui/actions/add-to-journey/journey-node';
import * as AnonymizeTextNode from 'ui/actions/anonymize-text/journey-node';
import * as AskAIAgentNode from 'ui/actions/ask-ai-agent/journey-node';
import * as AskAINode from 'ui/actions/ask-ai/journey-node';
import * as BranchNode from 'ui/actions/branch/journey-node';
import * as BranchBaseNode from 'ui/actions/branch_base/journey-node';
import * as BreakLoopNode from 'ui/actions/break-loop/journey-node';
import * as CalendarEvent from 'ui/actions/calendar-event/journey-node';
import * as CodeNode from 'ui/actions/code/journey-node';
import * as ComboSendFormNode from 'ui/actions/combo-send-form/journey-node';
import * as ConditionNodeV2 from 'ui/actions/condition-v2/journey-node';
import * as ConditionNode from 'ui/actions/condition/journey-node';
import * as ConvertDocumentNode from 'ui/actions/convert-document/journey-node';
import * as CreateDocumentNode from 'ui/actions/create-document/journey-node';
import * as ExtractTextNode from 'ui/actions/extract-text/journey-node';
import * as FormatterNode from 'ui/actions/formatter/journey-node';
import * as GhostNode from 'ui/actions/ghost/journey-node';
import * as HiddenNode from 'ui/actions/hidden/journey-node';
import * as IntegrationNode from 'ui/actions/integration/journey-node';
import * as LoopNode from 'ui/actions/loop/journey-node';
import * as MergeNode from 'ui/actions/merge/journey-node';
import * as PlaceholderNode from 'ui/actions/placeholder/journey-node';
import * as SendEmailNode from 'ui/actions/send-email/journey-node';
import * as SendSmsNode from 'ui/actions/send-sms/journey-node';
import * as StartNode from 'ui/actions/start/journey-node';
import * as TriggersNode from 'ui/actions/triggers/journey-node';
import * as UpdateFieldsNode from 'ui/actions/update-fields/journey-node';
import * as UpdateTravellerNode from 'ui/actions/update-traveller/journey-node';
import * as WaitForAttributeChangeNode from 'ui/actions/wait-for-attribute-change/journey-node';
import * as WaitForNode from 'ui/actions/wait-for/journey-node';
import * as WaitUntilFixedNode from 'ui/actions/wait-until-fixed/journey-node';
import * as WaitUntilRelativeNode from 'ui/actions/wait-until-relative/journey-node';
import * as WebhookNode from 'ui/actions/webhook/journey-node';

export const nodeTypes: Record<Exclude<ACTION_TYPE, 'instantiate_form'>, any> = {
  journey_start: StartNode,
  journey_triggers: TriggersNode,
  journey_branch: BranchNode,
  branch_base: BranchBaseNode,
  journey_merge: MergeNode,
  journey_loop: LoopNode,
  break_loop: BreakLoopNode,
  placeholder: PlaceholderNode,
  code: CodeNode,
  condition: ConditionNode,
  condition_v2: ConditionNodeV2,
  hidden: HiddenNode,
  ghost: GhostNode,
  integration: IntegrationNode,
  webhook: WebhookNode,
  wait_for_time: WaitForNode,
  wait_for_attribute_change: WaitForAttributeChangeNode,
  wait_until_fixed_date: WaitUntilFixedNode,
  wait_until_relative_date: WaitUntilRelativeNode,
  send_sms: SendSmsNode,
  combo_send_form: ComboSendFormNode,
  send_email: SendEmailNode,
  convert_document: ConvertDocumentNode,
  create_document: CreateDocumentNode,
  calendar_event: CalendarEvent,
  formatter: FormatterNode,
  ask_ai: AskAINode,
  ask_ai_agent: AskAIAgentNode,
  update_fields: UpdateFieldsNode,
  add_to_journey: AddToJourneyNode,
  update_traveller: UpdateTravellerNode,
  anonymize_text: AnonymizeTextNode,
  extract_text: ExtractTextNode,
};
